export function slugifyTitle(title) {
  return title
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9\s-]/g, '')
    .trim()
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
}

export function estimateReadTime(content) {
  const wordsPerMinute = 200
  const text = (content || '').replace(/<[^>]*>?/gm, '')
  const words = text.split(/\s+/).filter(Boolean).length
  return Math.max(1, Math.ceil(words / wordsPerMinute))
}

export function formatDate(date, format = 'dd/MM/yyyy') {
  if (!date) return ''
  const d = new Date(date)
  const day = String(d.getDate()).padStart(2, '0')
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const year = d.getFullYear()
  if (format === 'dd/MM/yyyy') return `${day}/${month}/${year}`
  if (format === 'yyyy-MM-dd') return `${year}-${month}-${day}`
  return `${day}/${month}/${year}`
}

export function formatNumber(n) {
  return new Intl.NumberFormat('pt-BR').format(n)
}

export function getPeriodDates(period) {
  const now = new Date()
  now.setHours(23, 59, 59, 999)
  const today = new Date(now)
  today.setHours(0, 0, 0, 0)

  let start, end, prevStart, prevEnd
  end = new Date(now)

  switch (period) {
    case 'today':
      start = new Date(today)
      prevEnd = new Date(start)
      prevEnd.setDate(prevEnd.getDate() - 1)
      prevStart = new Date(prevEnd)
      prevStart.setHours(0, 0, 0, 0)
      break
    case 'yesterday': {
      start = new Date(today)
      start.setDate(start.getDate() - 1)
      start.setHours(0, 0, 0, 0)
      end = new Date(start)
      end.setHours(23, 59, 59, 999)
      prevEnd = new Date(start)
      prevEnd.setDate(prevEnd.getDate() - 1)
      prevStart = new Date(prevEnd)
      prevStart.setHours(0, 0, 0, 0)
      break
    }
    case '7d':
      start = new Date(today)
      start.setDate(start.getDate() - 6)
      prevStart = new Date(start)
      prevStart.setDate(prevStart.getDate() - 7)
      prevEnd = new Date(start)
      prevEnd.setDate(prevEnd.getDate() - 1)
      prevEnd.setHours(23, 59, 59, 999)
      break
    case '15d':
      start = new Date(today)
      start.setDate(start.getDate() - 14)
      prevStart = new Date(start)
      prevStart.setDate(prevStart.getDate() - 15)
      prevEnd = new Date(start)
      prevEnd.setDate(prevEnd.getDate() - 1)
      prevEnd.setHours(23, 59, 59, 999)
      break
    case '30d':
      start = new Date(today)
      start.setDate(start.getDate() - 29)
      prevStart = new Date(start)
      prevStart.setDate(prevStart.getDate() - 30)
      prevEnd = new Date(start)
      prevEnd.setDate(prevEnd.getDate() - 1)
      prevEnd.setHours(23, 59, 59, 999)
      break
    case '60d':
      start = new Date(today)
      start.setDate(start.getDate() - 59)
      prevStart = new Date(start)
      prevStart.setDate(prevStart.getDate() - 60)
      prevEnd = new Date(start)
      prevEnd.setDate(prevEnd.getDate() - 1)
      prevEnd.setHours(23, 59, 59, 999)
      break
    case '90d':
      start = new Date(today)
      start.setDate(start.getDate() - 89)
      prevStart = new Date(start)
      prevStart.setDate(prevStart.getDate() - 90)
      prevEnd = new Date(start)
      prevEnd.setDate(prevEnd.getDate() - 1)
      prevEnd.setHours(23, 59, 59, 999)
      break
    case 'year':
      start = new Date(today)
      start.setFullYear(start.getFullYear() - 1)
      prevStart = new Date(start)
      prevStart.setFullYear(prevStart.getFullYear() - 1)
      prevEnd = new Date(start)
      prevEnd.setDate(prevEnd.getDate() - 1)
      prevEnd.setHours(23, 59, 59, 999)
      break
    default:
      start = new Date(today)
      start.setDate(start.getDate() - 29)
      prevStart = new Date(start)
      prevStart.setDate(prevStart.getDate() - 30)
      prevEnd = new Date(start)
      prevEnd.setDate(prevEnd.getDate() - 1)
      prevEnd.setHours(23, 59, 59, 999)
  }
  return { start, end, prevStart, prevEnd }
}
